import { X } from "lucide-react";

/**
 * ปุ่มปิด (X) ของหน้าต่าง — แบบเดียวทั้งแอป (Modal กลาง · ad-lab Modal/DetailShell · หน้าต่างที่วาดเอง)
 * เจ้าของระบบ 2026-10-16: X อยู่มุมขวาบนของทุกหน้าต่างเสมอ (มือถือ + จอใหญ่) ใหญ่และเห็นชัด
 * · 44×44px ทุกอุปกรณ์ (เป็น px ตรง ๆ เพราะ html = 18px → h-11 จะได้ 49.5px) · ไอคอน 20px · มีกรอบ + พื้น
 * · วางเป็นตัวสุดท้ายของแถวหัวหน้าต่าง (`flex items-start` · หัวข้อ `min-w-0 flex-1`) ห้ามวางต่อท้ายกลุ่มปุ่มที่ขึ้นบรรทัดใหม่ได้
 * ทางปิดหลักของหน้าต่าง (คลิกพื้นหลัง/Esc ไม่ปิด — ดู hooks/useDirtyClose)
 */
export function CloseButton({ onClick, disabled }: { onClick: () => void; disabled?: boolean }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label="ปิด"
      title="ปิด"
      className="inline-flex h-[44px] w-[44px] shrink-0 items-center justify-center rounded-xl border border-border bg-surface-raised text-slate-600 transition-colors hover:bg-surface-overlay hover:text-slate-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500/30 disabled:cursor-not-allowed disabled:opacity-50"
    >
      <X aria-hidden size={20} strokeWidth={2.25} />
    </button>
  );
}
